import React from "react";
import NotFoundDatas from "components/RFQ/NotFoundDatas/NotFoundDatas";
import { RenderOnViewportEntry } from "components/RFQ/RenderOnViewportEntry/RenderOnViewportEnter";
import { LoadingSpinner } from "components/Loading/LoadingSpinner";
import tw, { styled } from "twin.macro";
import ProjectTile from "components/Pages/Projects/ProjectTile/ProjectTile";

const SupplierCard = React.lazy(
	() => import("components/RFQ/SupplierCard/SupplierCard")
);

const GridViewStyled = styled.div((isNoDatas) => [
	tw`py-8 `,
	isNoDatas && tw`justify-center`,
]);

const GridViewSupplier = React.memo(
	({
		supplierLists,
		invitedSuppliers,
		handleInviteSupplier,
		handleRemoveSupplier,
		handleSelectAll,
		handleDeselectAll,
		isLoading = false,
	}) => {
		// Get suppliers from supplierLists if it's an array, otherwise use empty array
		const suppliers = Array.isArray(supplierLists) ? supplierLists : [];
		const allSelected = suppliers.length > 0 && invitedSuppliers?.length === suppliers.length;

		if (isLoading) {
			return <LoadingSpinner />;
		}

		return (
			<GridViewStyled isNoDatas={suppliers.length === 0}>
				{suppliers.length > 0 && (
					<div className="mb-4 flex items-center justify-between">
						<label className="flex cursor-pointer items-center gap-2">
							<div className="relative">
								<input
									type="checkbox"
									className="sr-only"
									checked={allSelected}
									onChange={allSelected ? handleDeselectAll : handleSelectAll}
								/>
								<div className={`h-5 w-9 rounded-full transition-colors ${allSelected ? "bg-royal-blue" : "bg-gray-300"}`} />
								<div className={`absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform ${allSelected ? "translate-x-4" : ""}`} />
							</div>
							<span className="text-sm font-medium text-tertiary-700">Select All</span>
						</label>
						<span className="text-sm text-tertiary-600">
							{invitedSuppliers?.length || 0} of {suppliers.length} selected
						</span>
					</div>
				)}
				<RenderOnViewportEntry
					loadingComponent={<ProjectTile />}
					className={`${suppliers.length > 0 ? "grid grid-cols-1 gap-8 lg:grid-cols-2 xlg:min-w-[680px] xlg:grid-cols-3 4xl:grid-cols-4" : "mx-auto w-1/2"}`}
				>
					<>
						{suppliers.length > 0 ? (
							<>
								{suppliers.map((supplier) => {
									return (
										<SupplierCard
											key={supplier?.id}
											supplier={supplier}
											handleInviteSupplier={handleInviteSupplier}
											handleRemoveSupplier={handleRemoveSupplier}
											isInvited={invitedSuppliers.includes(supplier.id)}
										/>
									);
								})}
							</>
						) : (
							<div className="mx-auto w-1/2">
								<NotFoundDatas
									text={`No supplier found`}
									description={`The supplier list is empty and needs suppliers to create a RFx`}
								/>
							</div>
						)}
					</>
				</RenderOnViewportEntry>
			</GridViewStyled>
		);
	}
);

export default GridViewSupplier;
